module.exports = __webpack_public_path__ + "img/nodejs-horizontal.7ca36356.svg";